<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="active" @tab-click="tabClick" v-if="showTabs">
          <el-tab-pane label="收租记录" name="collectRecord">
            <collect-record ref="collectRecord"  :room-id="roomId" :rent-record-id="rentRecordId"></collect-record>
          </el-tab-pane>
          <el-tab-pane label="退租记录" name="breakRecord">
            <break-record ref="breakRecord"  :room-id="roomId" :rent-record-id="rentRecordId"></break-record>
          </el-tab-pane>
          <el-tab-pane label="中介记录" name="agencyRecord">
            <agency-record ref="agencyRecord"  :room-id="roomId" :rent-record-id="rentRecordId"></agency-record>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>

import RentRecord from "@/components/RentRecord";
import CollectRecord from "@/components/CollectRecord";
import BreakRecord from "@/components/BreakRecord";
import AgencyRecord from "@/components/AgencyRecord";
import {getList as getRooms} from "@/api/room";

export default {
  components: {
    RentRecord,
    CollectRecord,
    BreakRecord,
    AgencyRecord
  },
  data() {
    return {
      active: 'collectRecord',
      roomId: 0,
      rentRecordId: 0,
      rooms: [],
      showTabs: false
    }
  },
  mounted() {
    this.roomId = parseInt(this.$route.query.roomId)
    this.rentRecordId = parseInt(this.$route.query.rentRecordId)
    setTimeout(() => {
      this.getRooms()
    }, 100);
  },
  methods: {
    getRooms() {
      getRooms().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.rooms = response.data
          this.showTabs = true
        }
      })
    },
    tabClick() {
      const tab = this.active
      if (tab == 'rentRecord') {
        this.$refs['rentRecord'].search(true)
      } else if (tab == 'collectRecord') {
        this.$refs['collectRecord'].search(true)
      } else if (tab == 'breakRecord') {
        this.$refs['breakRecord'].search(true)
      } else if (tab == 'agencyRecord') {
        this.$refs['agencyRecord'].search(true)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/rentRecordDetail.vue